import { Skeleton, Box } from '@mantine/core';

export const VideoGridSkeleton = () => {
  return (
    <Box
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: '16px',
        padding: '16px',
        width: '100%',
        height: '100%',
      }}
    >
      {/* Skeleton para 1 tile de vídeo */}
      <Box
        style={{
          position: 'relative',
          aspectRatio: '16/9',
          backgroundColor: '#2a2a2a',
          borderRadius: '12px',
          overflow: 'hidden',
        }}
      >
        <Skeleton
          height="100%"
          width="100%"
          radius="md"
          animate
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
          }}
        />

        {/* Avatar skeleton */}
        <Box
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          <Skeleton circle height={80} width={80} animate />
        </Box>

        {/* Name skeleton */}
        <Box
          style={{
            position: 'absolute',
            bottom: 16,
            left: 16,
          }}
        >
          <Skeleton height={20} width={120} radius="sm" animate />
        </Box>
      </Box>
    </Box>
  );
};
